import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "card-header" }
const _hoisted_2 = { class: "card-header__after" }

import ForbiddenView from '@/components/ForbiddenView.vue'
import NotFoundPage from '@/pages/NotFoundPage.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'PageWrapper',
  props: {
    title: {},
    code: {},
    className: {}
  },
  setup(__props: any) {

const props = __props

return (_ctx: any,_cache: any) => {
  const _component_el_card = _resolveComponent("el-card")!

  return (props.code === 403)
    ? (_openBlock(), _createBlock(ForbiddenView, { key: 0 }))
    : (props.code === 404)
      ? (_openBlock(), _createBlock(NotFoundPage, { key: 1 }))
      : (_openBlock(), _createBlock(_component_el_card, {
          key: 2,
          class: _normalizeClass(_ctx.className)
        }, _createSlots({
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "default")
          ]),
          _: 2
        }, [
          (props.title)
            ? {
                name: "header",
                fn: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("span", null, _toDisplayString(props.title), 1),
                    _createElementVNode("div", _hoisted_2, [
                      _renderSlot(_ctx.$slots, "after")
                    ])
                  ])
                ]),
                key: "0"
              }
            : undefined
        ]), 1032, ["class"]))
}
}

})